export const maskPhone = (v: string | undefined) => {
  if (!v) return '';
  let r = v.replace(/\D/g, '');
  if (r.length > 10) {
    r = r.substring(0, 10);
  }
  if (r.length > 6) {
    r = r.replace(/^(\d{3})(\d{3})(\d{0,4})*/, '($1) $2-$3');
  } else if (r.length > 3) {
    r = r.replace(/^(\d{3})(\d{0,3})/, '($1) $2');
  } else if (r.length > 0) {
    r = r.replace(/^(\d*)/, '($1');
  }
  return r;
};

export const maskSSN = (v: string) => {
  let r = v.replace(/\D/g, '');
  if (r.length > 5) {
    r = r.replace(/^(\d{3})(\d{2})(\d{0,4})*/, '$1-$2-$3');
  } else if (r.length > 3) {
    r = r.replace(/^(\d{3})(\d{0,3})/, '$1-$2');
  }
  return r;
};

export const maskZip = (v: string | undefined) => {
  if (!v) return '';
  let r = v.replace(/\D/g, '');
  if (r.length > 5) {
    r = r.replace(/^(\d{5})(\d{0,4})*/, '$1-$2');
  }
  return r;
};

export const maskDate = (v: string) => {
  // format MM/YYYY
  let r = v.replace(/\D/g, '');
  if (r.length > 2) {
    r = r.replace(/^(\d{2})(\d{0,4})*/, '$1/$2');
  }
  return r;
};

export const maskFullDate = (v: string) => {
  // format MM/DD/YYYY
  if (!v) return '';
  let r = v.replace(/\D/g, '');
  if (r.length > 4) {
    r = r.replace(/^(\d{2})(\d{2})(\d{0,4})*/, '$1/$2/$3');
  } else if (r.length > 2) {
    r = r.replace(/^(\d{2})(\d{0,2})/, '$1/$2');
  } else if (r.length > 0) {
    r = r.replace(/^(\d*)/, '$1');
  }
  return r;
};

export const zipRegexValidation = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const fullDateRegexValidation = /^\d{2}\/\d{2}\/\d{4}$/;
export const phoneNumberRegexValidation = /^\(\d{3}\) \d{3}-\d{4}$/;
